import { Injectable, computed, Signal } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';

@Injectable({
	providedIn: 'root'
})
export class WebcastViewService {
	public startingVideoSource$: Observable<boolean>;
	public waitingForVideoSource$: Observable<boolean>;
	public videoSourceNotReady$: Observable<boolean>;
	public automatedWebcast$: Observable<boolean>;
	public isSecondaryPlaying$: Observable<boolean>;
	public isPassiveStreamReady$: Observable<boolean>;
	public isEventAdminConnected$: Observable<boolean>;
	public passiveStreamStartRecordingFailed: Signal<boolean>;

	public initWebcastModelObservable(webcast: WebcastModel): void {
		const webcast$ = webcast.webcast$;
		this.passiveStreamStartRecordingFailed = computed(() => webcast.recording.passiveStreamStartRecordingFailed());

		this.startingVideoSource$ = webcast$.pipe(
			map((webcast: WebcastModel) => webcast.startingVideoSource),
			distinctUntilChanged()
		);

		this.waitingForVideoSource$ = webcast$.pipe(
			map((webcast: WebcastModel) => webcast.waitingForVideoSource),
			distinctUntilChanged()
		);

		this.videoSourceNotReady$ = combineLatest(
			[
				this.startingVideoSource$,
				this.waitingForVideoSource$
			]
		).pipe(
			map(([startingVideoSource, waitingForVideoSource]) => startingVideoSource || waitingForVideoSource),
			distinctUntilChanged()
		);

		this.automatedWebcast$ = webcast$.pipe(
			map((webcast: WebcastModel) => webcast.automatedWebcast),
			distinctUntilChanged()
		);

		this.isSecondaryPlaying$ = webcast$.pipe(
			map((webcast: WebcastModel) => webcast.isSecondaryPlaying),
			distinctUntilChanged()
		);

		this.isPassiveStreamReady$ = webcast$.pipe(
			map((webcast: WebcastModel) => webcast.isPassiveStreamReady),
			distinctUntilChanged()
		);

		this.isEventAdminConnected$ = webcast$.pipe(
			map((webcast: WebcastModel) => webcast.webcastStatus.isEventAdminConnected),
			distinctUntilChanged()
		);
	}
}
